import instance from "../../../services/api";

export const getAdditionalWorks = remont_id => {
  return instance(true)
    .get(`/partner/additional_work/remont/${remont_id}/ds/`)
    .then((res = {}) => res?.data);
};
